import { CustomerGateway } from '../domain/customer.gateway';
import { SearchCustomerInterface } from '../domain/customer.entity';

export class SearchbyIdUseCase {
    constructor(private gate: CustomerGateway) {}

    async execute(id: number): Promise<SearchCustomerInterface> {
        return this.gate.searchById(id);
    }
}
